import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { CheckCircle, Eye, XCircle } from "lucide-react";
import { createColumn } from "@/lib/table/columnFactory";
import type { LeaveRequest } from "./types";

export interface LeaveRequestActions {
  onView: (demande: LeaveRequest) => void;
  onApprove: (demande: LeaveRequest) => void;
  onReject: (demande: LeaveRequest) => void;
  canValidate: boolean;
}

export const actionsColumnFactory = (actions: LeaveRequestActions) =>
  createColumn<LeaveRequest>({
    id: "actions",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Actions" />,
    cell: ({ row }) => {
      const demande = row.original;
      const etatCode = demande.etatCode;
      const canAct = actions.canValidate && etatCode === "SOUMISE";

      return (
        <div className="flex items-center gap-1 flex-wrap">
          <button
            type="button"
            className="btn btn-xs btn-ghost btn-square"
            onClick={(e) => {
              e.stopPropagation();
              actions.onView(demande);
            }}
            title="Voir la demande"
          >
            <Eye className="w-4 h-4" />
          </button>

          {canAct && (
            <button
              type="button"
              className="btn btn-xs btn-soft btn-success"
              onClick={(e) => {
                e.stopPropagation();
                actions.onApprove(demande);
              }}
              title="Approuver la demande"
            >
              <CheckCircle className="w-3 h-3 mr-1" />
              Approuver
            </button>
          )}

          {canAct && (
            <button
              type="button"
              className="btn btn-xs btn-soft btn-error"
              onClick={(e) => {
                e.stopPropagation();
                actions.onReject(demande);
              }}
              title="Refuser la demande"
            >
              <XCircle className="w-3 h-3 mr-1" />
              Refuser
            </button>
          )}

          {!canAct && (
            <span className="text-xs text-base-content/50 italic">
              {etatCode === "APPROUVEE" && "Approuvée"}
              {etatCode === "REFUSEE" && "Refusée"}
              {etatCode === "ANNULEE" && "Annulée"}
            </span>
          )}
        </div>
      );
    },
    enableHiding: false,
    enableSorting: false,
  });
